// utils/googleLoginUtils.ts

import { useGoogleLogin, TokenResponse } from '@react-oauth/google';
import { message } from 'antd';
import loginApi from '@/service/modules/loginApi'
import { updateUserInfo } from '@/store/slices/userInfoSlice';
import { useDispatch } from "react-redux"
import { setCookie } from '@/utils/cookie'

interface GoogleLoginProps {
  onSuccessJump?: () => void;
}

export const useGoogleLoginUtils = ({ onSuccessJump }: GoogleLoginProps) => {
  const dispatch = useDispatch();

  const onGoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse: TokenResponse) => {
      try {
        console.log('Login Success:', tokenResponse);
        let res = await loginApi.googleLogin({ access_token: tokenResponse.access_token });
        if (res.data) {
          console.log(res, ' == res');
          message.success('Login Successful!');

          // Matomo 记录登录结果
          let LoginResult = {
            login_method: 'google',
            is_success: true,
            fail_reason: null
          }
          if (window && (window as any)._paq) {
            (window as any)._paq.push(['setUserId', res.data.customerID]);
            (window as any)._paq.push(['setCustomDimension', 26, JSON.stringify(LoginResult)]);
            (window as any)._paq.push(['trackPageView']);
          }

          // 保存 userEmail
          if (res.data.email) {
            localStorage.setItem('userEmail', res.data.email || '');
            setCookie('userCustomerId', res.data.customerID || '');
          } else {
            localStorage.removeItem('userEmail');
          }

          // 登录成功，跳转
          if (onSuccessJump) {
            dispatch(updateUserInfo(res.data));
            setTimeout(() => {
              onSuccessJump();
            }, 1500);
          }
        } else {
          message.error('Google Login Failure');
        }
      } catch (error) {
        message.error('Google Login Failure');
      }
    },
    onError: () => {
      console.error('Google Login Failure');
      message.error('Google Login Failure');
    },
  });

  return onGoogleLogin;
};
